import { FC } from 'react';

import { Box, TableBody, TableCell, TableRow, Typography } from '@mui/material';
import clsx from 'clsx';
import { ONE_PAGE_STYLE_OPTIONS } from 'layouts/OnePagePreviewLayout/types';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getBusinessPlan } from 'store/useBusinessToolStore/selectors';

import { GANTT_FIRST_COLUMN_WIDTH } from 'components/OnePageTemplates/common/GanttChart/constants/ganttChart';
import { STYLE_VARIANTS } from 'components/OnePageTemplates/interfaces/variants';

import { IGanttChartBodyProps as IProps } from './types';
import { GanttDurationLine } from '../GanttDurationLine';

import styles from './GanttChartBody.module.scss';

export const GanttChartBody: FC<IProps> = ({ chartData, monthWidth, variant }) => {
  const businessPlan = useBusinessToolStore(getBusinessPlan);
  const isOutlined = variant === STYLE_VARIANTS.OUTLINED;

  const onePageVariant = businessPlan.metadata.onePageTemplateStyle;

  return (
    <TableBody className={styles.tableBody}>
      {chartData.map(({ stage, duration, from, to, differenceWithStartDate, status }, index) => (
        <TableRow key={stage}>
          <TableCell
            className={clsx(styles.stageWrapper, {
              [styles.outlined]: isOutlined,
              [styles.last]: chartData.length - 1 === index,
            })}
            sx={{
              width: `${GANTT_FIRST_COLUMN_WIDTH}px`,
              minWidth: `${GANTT_FIRST_COLUMN_WIDTH}px`,
            }}
          >
            <Typography
              component="p"
              className={clsx(styles.stagesLabel, {
                [styles.outlined]: isOutlined,
                [styles['stageLabel-second-style']]: onePageVariant === ONE_PAGE_STYLE_OPTIONS.SECOND_STYLE,
                [styles['stageLabel-first-style']]: onePageVariant !== ONE_PAGE_STYLE_OPTIONS.SECOND_STYLE,
              })}
              variant="subtitle1"
            >
              {stage}
            </Typography>
          </TableCell>
          <TableCell
            className={clsx(styles.durationWrapper, {
              [styles.last]: chartData.length - 1 === index,
            })}
          >
            <GanttDurationLine
              duration={duration}
              monthWidth={monthWidth}
              differenceWithStartDate={differenceWithStartDate}
              dateFrom={from}
              dateTo={to}
              status={status}
              variant={variant}
            />
          </TableCell>
        </TableRow>
      ))}
      <TableRow>
        <TableCell className={styles.lastStageWrapper}>
          <Box className={styles.lastStage} />
        </TableCell>
        <TableCell className={styles.lastDurationWrapper} />
      </TableRow>
    </TableBody>
  );
};
